import { render, staticRenderFns } from "./ShotList.vue?vue&type=template&id=4add06f6"
import script from "./ShotList.vue?vue&type=script&lang=js"
export * from "./ShotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports